import { Link, Router } from "react-router-dom";
import Select from 'react-select';
import { styleSelect } from "../constants/customStyles";
import { getLogs, toggleLogs } from "../actions/DashboardActions";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

function Topbar() {
    const dispatch = useDispatch();

    const customOptions = [
        { value: '1', label: 'Garage Management' },
        { value: '233', label: 'Sales' },
        { value: '175', label: 'Invoicing' },
        { value: '369', label: 'Purchase' },
        { value: '307', label: 'Inventory' },
    ]

    const user_name = JSON.parse(localStorage.getItem('user_name'));

    const handleChange = (menu_id) => {
        if (menu_id != 1) {
            window.open(`http://165.73.244.174:8069/web#menu_id=${menu_id}`, '_blank')
        }
    }

    useEffect(() => {
        dispatch(getLogs());
    }, [])

    const logs = useSelector(state => state?.dashboard?.logs);

    const toggleStatus = async () => {
        dispatch(toggleLogs(logs.value));
        await dispatch(getLogs());
    }

    return (

        <div class="top-bar">
            <div class="search me-auto d-none d-sm-flex">
                {/* <input type="text" className="ms-9 search__input form-control border-transparent" placeholder="Search..." />
                <svg className=" me-2 w-6 h-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-search search__icon dark-text-gray-300"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg> */}
            </div>
            <label className="form-label me-2 fs-base mt-2">Log Status:</label>
            <div className="d-flex align-items-center form-check form-switch">
                <input
                    type="checkbox"
                    onClick={toggleStatus}
                    defaultChecked={logs.value}
                    className="form-check-input"
                />
            </div>
            {/* <div class="intro-x position-relative w-50 me-3 me-sm-6">
                <Select value={{ value: '1', label: 'Garage Management' }} styles={styleSelect} options={customOptions} onChange={(e) => handleChange(e.value)} />
            </div> */}
            <div class="intro-x dropdown w-8 h-8">
                <div class="dropdown-toggle w-8 h-8 rounded-pill overflow-hidden shadow-lg image-fit zoom-in" role="button" aria-expanded="false" data-bs-toggle="dropdown">
                    <img alt="Rubick Tailwind HTML Admin Template" src="/images/avatar.png" />
                </div>
                <div class="dropdown-menu w-56">
                    <ul class="dropdown-content bg-primary text-white">
                        <li class="p-2">
                            <div class="fw-medium text-white">{user_name}</div>
                            {/* <div class="fs-xs text-theme-28 mt-0.5 dark-text-gray-600">Admin</div> */}
                        </li>
                        <li>
                            <hr class="dropdown-divider border-theme-27 dark-border-dark-3" />
                        </li>
                        {/* <li>
                            <a href="" class="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="user" class="w-4 h-4 me-2"></i> Profile </a>
                        </li>
                        <li>
                            <a href="" class="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="edit" class="w-4 h-4 me-2"></i> Add Account </a>
                        </li>
                        <li>
                            <a href="" class="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="lock" class="w-4 h-4 me-2"></i> Reset Password </a>
                        </li>
                        <li>
                            <a href="" class="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="help-circle" class="w-4 h-4 me-2"></i> Help </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider border-theme-27 dark-border-dark-3" />
                        </li> */}
                        <li>
                            <Link onClick={() => { localStorage.removeItem('user'); localStorage.removeItem('perm') }} to="/" class="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="toggle-right" class="w-4 h-4 me-2"></i> Logout </Link>
                        </li>
                    </ul>
                </div>
            </div>  
            {/* <!-- END: Account Menu --> */}
        </div>
    )
}
export default Topbar;